import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'spotlight-response-footer',
    standalone: true,
    imports: [CommonModule, MatIconModule],
    templateUrl: './response-footer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpotlightResponseFooterComponent {
    @Input() executionTimeMs: number = 0;
    @Input() currentPage: number = 0;
    @Input() totalPages: number = 1;
    @Input() showPagination: boolean = false;

    @Output() previousPageClick = new EventEmitter<void>();
    @Output() nextPageClick = new EventEmitter<void>();

    onPreviousPage(): void {
        this.previousPageClick.emit();
    }

    onNextPage(): void {
        this.nextPageClick.emit();
    }

    get canGoPrevious(): boolean {
        return this.currentPage > 0;
    }

    get canGoNext(): boolean {
        return this.currentPage < this.totalPages - 1;
    }
}
